import { render, staticRenderFns } from "./studyAddMember.vue?vue&type=template&id=bb47f360&scoped=true&"
import script from "./studyAddMember.vue?vue&type=script&lang=js&"
export * from "./studyAddMember.vue?vue&type=script&lang=js&"
import style0 from "./studyAddMember.vue?vue&type=style&index=0&id=bb47f360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb47f360",
  null
  
)

export default component.exports